import DesktopWorkerDetail from "./DesktopWorkerDetail";

export default DesktopWorkerDetail;
